import {
	OPINION_DECISION,
	OPINION_SOURCE,
} from '../../constants/opinion.constants';
import useChatFeedback from '../../hooks/useChatFeedback';
import useMessageSpeech, { MESSAGE_SPEECH_STATE } from '../../hooks/useMessageSpeech';
import ChatFeedbackModal from '../chatFeedback/ChatFeedbackModal';
import {
	MessageActionsRoot,
	MessageActionButton,
	ActionIcon,
	SpeakerSpinner,
} from './messageActions.styles';

const ThumbUpIcon = () => (
	<ActionIcon viewBox="0 0 24 24" aria-hidden="true">
		<path d="M7 11v9H3v-9h4Z" />
		<path d="M7 18h10.2a2 2 0 0 0 1.9-1.4l1.5-5A2 2 0 0 0 18.7 9H14l.7-3.2A2.3 2.3 0 0 0 12.5 3L7 11v7Z" />
	</ActionIcon>
);

const ThumbDownIcon = () => (
	<ActionIcon viewBox="0 0 24 24" aria-hidden="true">
		<path d="M7 13V4H3v9h4Z" />
		<path d="M7 6h10.2a2 2 0 0 1 1.9 1.4l1.5 5a2 2 0 0 1-1.9 2.6H14l.7 3.2a2.3 2.3 0 0 1-2.2 2.8L7 13V6Z" />
	</ActionIcon>
);

const SpeakerIcon = () => (
	<ActionIcon viewBox="0 0 24 24" aria-hidden="true">
		<path d="M5 10v4h3l4 4V6l-4 4H5Z" />
		<path d="M16 9a4 4 0 0 1 0 6" />
		<path d="M18.5 6.5a7.5 7.5 0 0 1 0 11" />
	</ActionIcon>
);

const MessageActions = ({ person, text, messageKey }) => {
	const {
		t,
		activeDecision,
		text: feedbackText,
		setText,
		selectedDecision,
		handleIconClick,
		cancelFeedback,
		skipFeedback,
		submitFeedback,
		isSubmitDisabled,
		isSubmitting,
	} = useChatFeedback(person, {
		source: OPINION_SOURCE.MESSAGE,
		ratedMessage: text,
	});

	const { speechState, handleSpeak, canSpeak } = useMessageSpeech({
		person,
		text,
		messageKey,
	});

	const isSpeaking = speechState === MESSAGE_SPEECH_STATE.SPEAKING;
	const isLoading = speechState === MESSAGE_SPEECH_STATE.LOADING;

	return (
		<>
			<MessageActionsRoot aria-label={t.messageActionsLabel}>
				<MessageActionButton
					type="button"
					$active={selectedDecision === OPINION_DECISION.HAND_UP}
					onClick={() => handleIconClick(OPINION_DECISION.HAND_UP)}
					aria-label={t.feedbackLikeTitle}
					data-tooltip={t.tooltipLike}
				>
					<ThumbUpIcon />
				</MessageActionButton>
				<MessageActionButton
					type="button"
					$active={selectedDecision === OPINION_DECISION.HAND_DOWN}
					onClick={() => handleIconClick(OPINION_DECISION.HAND_DOWN)}
					aria-label={t.feedbackDislikeTitle}
					data-tooltip={t.tooltipDislike}
				>
					<ThumbDownIcon />
				</MessageActionButton>
				<MessageActionButton
					type="button"
					$active={isSpeaking}
					$loading={isLoading}
					onClick={handleSpeak}
					disabled={!canSpeak}
					data-tooltip={
						isLoading
							? t.speakLoading
							: isSpeaking
								? t.speakStop
								: t.tooltipListen
					}
					aria-label={
						isLoading
							? t.speakLoading
							: isSpeaking
								? t.speakStop
								: t.listenToMessage
					}
				>
					{isLoading ? <SpeakerSpinner /> : <SpeakerIcon />}
				</MessageActionButton>
			</MessageActionsRoot>
			<ChatFeedbackModal
				activeDecision={activeDecision}
				text={feedbackText}
				setText={setText}
				cancelFeedback={cancelFeedback}
				skipFeedback={skipFeedback}
				submitFeedback={submitFeedback}
				isSubmitDisabled={isSubmitDisabled}
				isSubmitting={isSubmitting}
				t={t}
			/>
		</>
	);
};

export default MessageActions;
